// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__suv-h","buttons":"styles_buttons__2BFmu"};